/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface FunktionsbereichAbteilung { 
    funktionsbereich_id: string;
    bezeichnung: string;
    rufnummer?: string;
    ist_aktiv?: boolean;
    zentrale_darf_delegieren?: boolean;
    mandant_id?: string;
    modified_on_utc?: Date;
}

